
import React from 'react';

const Calendar = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="32"
			height="32"
			fill="none"
			viewBox="0 0 32 32"
		>
			<path
				fill="#2d2d2d"
				d="M25 6h-1v2h1c.55 0 1 .45 1 1v1H7v2h19v14H6V9c0-.55.45-1 1-1h4V4H9v2H7C5.35 6 4 7.35 4 9v18c0 .55.45 1 1 1h22c.55 0 1-.45 1-1V9c0-1.65-1.35-3-3-3z"
			></path>
			<path
				fill="#2d2d2d"
				d="M22 8h1V4h-2v2h-9v2h10zM11 14H9v2h2v-2zM15 14h-2v2h2v-2zM19 14h-2v2h2v-2zM23 14h-2v2h2v-2zM11 18H9v2h2v-2zM15 18h-2v2h2v-2zM19 18h-2v2h2v-2zM23 18h-2v2h2v-2zM11 22H9v2h2v-2zM15 22h-2v2h2v-2zM19 22h-2v2h2v-2z"
			></path>
		</svg>
	);
};

export default Calendar;
